import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 text-white">
      <div className="container-custom py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-play-circle-fill text-white text-xl" style={{ width: '22px', height: '22px' }}></i>
              </div>
              <span className="font-heading font-bold text-lg">糖心在线看</span>
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed">
              17c·moc起草糖心在线看——免费高清视频平台，海量资源在线看，无需下载，多终端兼容，随时随地畅享流畅观影体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-white">
              视频分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-white">
              更多分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-white">
              关于我们
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer"
                >
                  联系我们
                </Link>
              </li>
              <li>
                <a
                  href="#faq"
                  className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer"
                >
                  常见问题
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {currentYear} 17c·moc起草糖心在线看 版权所有 | 免费高清视频在线播放平台
          </p>
          <div className="flex items-center gap-4">
            <span className="text-foreground-500 text-xs">高清视频免费在线看</span>
            <span className="text-foreground-500 text-xs">糖心在线看免费入口</span>
          </div>
        </div>
      </div>
    </footer>
  );
}